import React, {Component} from 'react';

export default class MatchNoResults extends Component {
  render() {
    return <p className="no-results">No results found :( Try tweaking your search</p>;
  }
}
